var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60713 49.6379C9.08809 47.0142 11.2038 44.3317 14.618 42.0163C20.7657 37.8468 27.787 37.864 34.8149 37.6038C37.1473 37.5173 43.41 37.4888 50 37.5038C56.59 37.4888 62.8529 37.5173 65.185 37.6038C72.2129 37.864 79.2342 37.8468 85.3821 42.0163C88.7963 44.3317 90.9121 47.0142 91.3929 49.6379C91.8058 51.89 91.7421 59.6183 91.2658 65.0721C91.0146 67.9471 90.7592 69.3467 90.3775 69.935C89.2263 71.7096 85.9025 73.2021 81.0133 74.1392C76.425 75.0187 77.1071 75 50 75C22.8928 75 23.575 75.0187 18.9868 74.1392C14.0975 73.2021 10.7739 71.7096 9.62251 69.935C9.24101 69.3467 8.98538 67.9471 8.73417 65.0721C8.25784 59.6183 8.19417 51.89 8.60713 49.6379Z",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 37.5L24.2219 18.7088C24.7245 17.4587 25.7013 16.4146 27.0778 15.9465C40.5902 11.3512 59.4096 11.3512 72.9221 15.9465C74.2988 16.4146 75.2754 17.4587 75.7783 18.7088L81.25 37.5",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 50L16.6667 52.0833",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5833 50L83.3333 52.0833",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 72.9167L34.357 70.3575C35.8792 66.5521 36.6403 64.6492 38.2276 63.5746C39.8147 62.5 41.8642 62.5 45.9629 62.5H54.0371C58.1358 62.5 60.1854 62.5 61.7725 63.5746C63.3596 64.6492 64.1208 66.5521 65.6429 70.3575L66.6667 72.9167",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1734 77.3429V80.685C29.1736 84.3283 29.0141 85.0108 27.9142 86.0746C27.5924 86.3854 26.9383 86.8337 26.4609 87.0704C25.6249 87.4842 25.3446 87.5 18.8653 87.5C12.2405 87.5 12.122 87.4929 11.1012 87.0317C10.5308 86.7737 9.8114 86.2588 9.5024 85.8867C8.41165 84.5742 8.35978 84.1871 8.34961 77.2746L8.3524 62.5",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8267 77.3429V80.685C70.8262 84.3283 70.9858 85.0108 72.0858 86.0746C72.4075 86.3854 73.0617 86.8337 73.5392 87.0704C74.375 87.4842 74.6554 87.5 81.1346 87.5C87.7596 87.5 87.8779 87.4929 88.8987 87.0317C89.4692 86.7737 90.1887 86.2588 90.4975 85.8867C91.5883 84.5742 91.64 84.1871 91.6504 77.2746L91.6475 62.5",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3333 37.5001L89.5833 35.4167",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 37.5001L10.4167 35.4167",
    stroke: "#929292",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarGrey);
export default __webpack_public_path__ + "static/media/car-grey.71f4dccb12e5fa5ddd974f91c3349dfe.svg";
export { ForwardRef as ReactComponent };